import { Component, ViewContainerRef } from '@angular/core';
import { Router} from '@angular/router';
import { Announcement } from '../../models/announcement/announcement.model';
import { Customer } from '../../models/customer/customer-model'
import { CustomerService } from '../../services/customer/customer.service';
import { AnnouncementService } from '../../services/announcement/announcement.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-create-announcement',
    templateUrl: './create-announcement.component.html',
    styleUrls: ['./create-announcement.component.css']
})
/** create-announcement component*/
export class CreateAnnouncementComponent {
  public announcement = new Announcement();
  public customerList: Customer[];
  public startDateElement: any;
  public endDateElement: any;
  minDate: Date;
  maxDate: Date;
  endMaxDate: Date;
    /** create-announcement ctor */
  constructor(private readonly announcementService: AnnouncementService,
    private readonly customerService: CustomerService,
    private readonly toastr: ToastsManager, vcr: ViewContainerRef, private readonly rolePermissionService: RolePermissionService, private readonly router: Router) {
    this.rolePermissionService.GetRolePermissions("announcement").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            this.announcement.isActive = true;
            this.announcement.customerID = 0;
            this.getVendors();
          }
          else {
            this.router.navigate(["/announcement-list"]);
          }
        }
        else {
          this.router.navigate(["/announcement-list"]);
        }
      }
    )
    this.minDate = new Date();
    this.maxDate = new Date();
    this.endMaxDate = new Date();
    this.minDate.setDate(this.minDate.getDate());
  }

  getVendors() {
    this.customerService.getVendorsList().subscribe(
      data => {
        this.customerList = data;
      }
    )
  }

  onSubmit() {
    this.startDateElement = document.getElementById("startDate") as HTMLElement;
    this.endDateElement = document.getElementById("endDate") as HTMLElement;
    if (this.startDateElement.value != "" && this.endDateElement.value != "") {
      this.announcement.startDate = this.startDateElement.value;
      this.announcement.endDate = this.endDateElement.value;
    } else {
      this.announcement.startDate = new Date().toDateString();
      this.announcement.endDate = new Date().toDateString();
    }
    this.toastr.success('Announcement saved successfully.', 'Success');
    this.announcementService.AddAnnouncement(this.announcement);
  }
  selectStartDate(e) {

    if (e != null) {
      this.announcement.startDate = e;
      this.maxDate = e;
      this.endMaxDate = new Date(this.maxDate);
     // this.endMaxDate.setDate(this.maxDate.getDate() + 1);
    }
  }
  selectEndDate(e) {
    if (e != null) {
      this.announcement.endDate = e;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/announcement-components/create-announcement/create-announcement.component.ts